import { Dropdown, ResponsiveMode } from "@fluentui/react";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import React from "react";
import useCoObjectSourceAmountAnalyticalPanel, { DatasetAmountDropdownOption } from "./AnalyticalAmountSourcePanelHook";
import { TgkAmountObjectSource } from "../../interfaces/CoObject";
import { DatasetField } from "../../../api/models/dataset-field";
import { ObjectPanelTabs } from "../co-panel/ObjectPanelComponent";

export interface CoObjectSourceAnalyticalAmountProps {
  objectSource: TgkAmountObjectSource;
  datasetFields?: DatasetField[] | undefined;
  updateSource: (obj: TgkAmountObjectSource, tabValid: any, modified: boolean) => void;
  validateSource: (obj: TgkAmountObjectSource) => ObjectPanelTabs;
  isEdit: boolean;
  isLocked: boolean;
  isComponentInstance: boolean;
}

export const AnalyticalAmountSourcePanel: React.FunctionComponent<CoObjectSourceAnalyticalAmountProps> = (props) => {
  const {
    objectSource,
    amountOptions,
    datasetOptions,
    analyticalWorkspaceOptions,
    isComponentInstance,
    isLocked,
    handleOnChangeAnalyticalWorkspace,
    handleOnChangeDataset,
    handleOnChangeAmount,
  } = useCoObjectSourceAmountAnalyticalPanel(props);

  return (
    <>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <Dropdown
          id="analytical_workspace_dropdown"
          placeholder={formatMessage(
            analyticalWorkspaceOptions == null ||
              (analyticalWorkspaceOptions.length == 0 && objectSource?.dbApplication)
              ? `cof.createnewobject.analyticalworkspace.noavailable`
              : "cof.base.select"
          )}
          label={formatMessage("cof.createnewobject.analyticalworkspace")}
          options={analyticalWorkspaceOptions}
          selectedKey={objectSource?.analyticalWorkspace?.code ?? null}
          onChange={(_event, selectedOption) =>
            handleOnChangeAnalyticalWorkspace(selectedOption ? selectedOption : undefined)
          }
          responsiveMode={ResponsiveMode.large}
          disabled={!objectSource?.dbApplication?.id || isComponentInstance || isLocked}
          required
        />
      </div>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <Dropdown
          id="dataset_dropdown"
          placeholder={formatMessage(
            datasetOptions == null || (datasetOptions.length == 0 && objectSource?.analyticalWorkspace?.code)
              ? `cof.createnewobject.dataset.noavailable`
              : "cof.base.select"
          )}
          label={formatMessage("cof.createnewobject.dataset")}
          options={datasetOptions}
          selectedKey={objectSource?.dataset?.code ?? null}
          onChange={(_event, selectedOption: DatasetAmountDropdownOption) =>
            handleOnChangeDataset(selectedOption ? selectedOption : undefined)
          }
          responsiveMode={ResponsiveMode.large}
          disabled={!objectSource?.analyticalWorkspace?.code || isComponentInstance || isLocked}
          required
        />
      </div>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <Dropdown
          id="amount_dropdown"
          placeholder={formatMessage(
            amountOptions == null || (amountOptions.length == 0 && objectSource?.dataset?.code)
              ? `cof.createnewobject.amount.noavailable`
              : "cof.base.select"
          )}
          label={formatMessage("cof.createnewobject.amount")}
          options={amountOptions}
          selectedKey={objectSource?.amount?.id ?? null}
          onChange={(_event, selectedOption) => handleOnChangeAmount(selectedOption ? selectedOption : undefined)}
          disabled={!objectSource?.dataset?.code || isComponentInstance || isLocked}
          responsiveMode={ResponsiveMode.large}
          required
        />
      </div>
    </>
  );
};
